import ResizablePanel from 'components/Panel/ResizablePanel';
import React, { useRef, useEffect, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setActiveLeftPanelTab, setLeftPanelWidth } from 'redux/mode/actions';
import { LeftPanelTab } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import { selectActiveScene } from 'redux/db/reducers';
import * as Base from '../styles';
import DesignSystem from './DesignSystem';
import FrameList from './FrameList';
import TabBar from './TabBar';
import * as S from './styles';
import SceneChatPanel from '../Chat/ChatPanel/SceneChatPanel';

const LeftPanel = () => {
	const dispatch = useDispatch();
	const ref = useRef() as React.MutableRefObject<HTMLDivElement>;

	const { leftPanelWidths, activeLeftPanelTab, activeScene } = useSelector((r: RootReducer) => {
		return {
			leftPanelWidths: r.mode.leftPanelWidths,
			activeLeftPanelTab: r.mode.activeLeftPanelTab,
			activeScene: selectActiveScene(r.db, r.mode.activeSceneId),
		};
	}, shallowEqual);

	const shouldShowDesignSystemTab = useMemo(() => {
		return !!activeScene?.metadata?.styles?.length;
	}, [activeScene?.metadata?.styles]);

	const availableTabs = useMemo(() => {
		const allTabs = Object.values(LeftPanelTab);
		if (!shouldShowDesignSystemTab) {
			return allTabs.filter((tab) => tab !== LeftPanelTab.DESIGN_SYSTEM);
		}
		return allTabs;
	}, [shouldShowDesignSystemTab]);

	useEffect(() => {
		if (activeLeftPanelTab === LeftPanelTab.DESIGN_SYSTEM && !shouldShowDesignSystemTab) {
			dispatch(setActiveLeftPanelTab(LeftPanelTab.CHAT));
		}
	}, [activeLeftPanelTab, shouldShowDesignSystemTab, dispatch]);
	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<ResizablePanel
			resizeOnSide="right"
			size={leftPanelWidths[activeLeftPanelTab]}
			onResize={(w) => {
				dispatch(setLeftPanelWidth({ tab: activeLeftPanelTab, width: w }));
			}}
		>
			<Base.Base ref={ref}>
				<S.Top>
					<TabBar
						labels={availableTabs}
						activeLabel={activeLeftPanelTab}
						onChange={(tab) => dispatch(setActiveLeftPanelTab(tab as LeftPanelTab))}
					/>
				</S.Top>
				<Base.Divider />
				{activeLeftPanelTab === LeftPanelTab.CHAT && <SceneChatPanel />}
				{activeLeftPanelTab === LeftPanelTab.DOCUMENT && <FrameList />}
				{activeLeftPanelTab === LeftPanelTab.DESIGN_SYSTEM && shouldShowDesignSystemTab && (
					<DesignSystem />
				)}
			</Base.Base>
		</ResizablePanel>
	);
};

export default LeftPanel;
